import * as React from "react"
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Badge,
  Container,
  useMediaQuery,
  useTheme,
  Button,
  Tooltip,
  Avatar,
  Menu,
  MenuItem,
} from "@mui/material"
import NotificationsIcon from "@mui/icons-material/Notifications"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import MenuIcon from "@mui/icons-material/Menu"
import { useNavigate, useLocation } from "react-router-dom"
import { useContext, useEffect } from "react"
import AuthContext from "../../AuthContext"
import logo from "../../assets/150x150.png"
import { Link } from "react-router-dom"
import { fontSize } from "@mui/system"

const pages = ["Dashboard", "Claims", "Support"]
const adminPage = "Admin"
const settings = ["Profile", "Logout"]

function ResponsiveAppBar() {
  const theme = useTheme()

  const [anchorElNav, setAnchorElNav] = React.useState(null)
  const [anchorElUser, setAnchorElUser] = React.useState(null)
  const navigate = useNavigate()
  const { logout, userRole, accCode, isAuthenticated, firstName, email } =
    useContext(AuthContext)
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
  const avatarName = accCode ? accCode.toUpperCase() : "?"

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget)
  }

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget)
  }

  const handleCloseNavMenu = () => {
    setAnchorElNav(null)
  }

  const handleCloseUserMenu = () => {
    setAnchorElUser(null)
  }

  const handleLogout = () => {
    logout()
    handleCloseUserMenu()
    navigate("/home")
  }

  const handleMenuItemClick = (setting) => {
    if (setting === "Logout") {
      handleLogout()
    } else if (setting === "Profile") {
      navigate("/profile")
      handleCloseUserMenu()
    } else {
      handleCloseUserMenu()
    }
  }

  return (
    <AppBar position="relative" sx={{ zIndex: 10 }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Link to="/dashboard">
            <img
              src={logo}
              alt="logo"
              style={{ width: "50px", height: "50px", marginTop: "8px" }}
            />
          </Link>
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/dashboard"
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontWeight: 700,
              color: "white",
              textDecoration: "none",
            }}
          >
            BGA
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page) => (
                <Link
                  to={`/${page.toLowerCase()}`}
                  key={page}
                  style={{ textDecoration: "none" }}
                >
                  <MenuItem key={page} onClick={handleCloseNavMenu}>
                    <Typography textAlign="center">{page}</Typography>
                  </MenuItem>
                </Link>
              ))}
              {userRole === "admin" && (
                <Link
                  to={`/${adminPage.toLowerCase()}`}
                  key={adminPage}
                  style={{ textDecoration: "none" }}
                >
                  <MenuItem key={adminPage} onClick={handleCloseNavMenu}>
                    <Typography textAlign="center">{adminPage}</Typography>
                  </MenuItem>
                </Link>
              )}
            </Menu>
          </Box>
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontWeight: 700,
              fontSize: { xs: "1.2rem", md: "1.5rem", lg: "1.5rem" },
              color: "inherit",
              textDecoration: "none",
            }}
          >
            BGA
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {pages.map((page) => (
              <Link
                to={`/${page.toLowerCase()}`}
                key={page}
                style={{ textDecoration: "none" }}
              >
                <Button
                  onClick={handleCloseNavMenu}
                  sx={{ my: 2, color: "white", display: "block" }}
                >
                  <p>{page}</p>
                </Button>
              </Link>
            ))}
            {userRole === "admin" && (
              <Link
                to={`/${adminPage.toLowerCase()}`}
                key={adminPage}
                style={{ textDecoration: "none" }}
              >
                <Button
                  onClick={handleCloseNavMenu}
                  sx={{ my: 2, color: "white", display: "block" }}
                >
                  <p>{adminPage}</p>
                </Button>
              </Link>
            )}
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            {isAuthenticated && (
              <Link to={"/new-claim"} style={{ textDecoration: "none" }}>
                <Button
                  variant="contained"
                  color="secondary"
                  sx={{ my: 2, mx: 5, fontSize: isMobile ? "0.7em" : "0.9em" }}
                >
                  <p>NEW CLAIM</p>
                </Button>
              </Link>
            )}
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt={avatarName} src="/src/assets/150x150.png" />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem
                  key={setting}
                  onClick={() => handleMenuItemClick(setting)}
                >
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default ResponsiveAppBar
